import { BaseService } from "../services/base.service";
import 'reflect-metadata';

export default function action(aliasName: string): (
  target: object,
  propertyKey: string,
) => void {
  return (target: object, methodName: string): void => {
    let sagas: object[] = Reflect.getMetadata('sagas', BaseService) || [];
    sagas.push({className: aliasName, methodName});
    Reflect.defineMetadata('sagas', sagas, BaseService);
  };
}
